import React, { useState } from 'react'
import { Button, Card, Modal, Row, Tooltip, notification } from 'antd'
import { CopyOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom'
import { QRCode } from 'react-qrcode-logo'
import CONSTANTS from '../../../../util/constant/CONSTANTS';
import Heading from '../../../../component/common/Heading';
import CRUDComponent from '../../../../component/common/CRUD-Component';
import { DEVICE } from '../../../../util/functions';
import { role } from '../../../../util/Route';

const Devices = () => {
    // const deviceTypeId = id.split('-')
    const [qrData, setQrData] = useState(null)
    const navigate = useNavigate();


    const copyHandler = (id, type = "Unique") => {
        try {
            window.navigator.clipboard.writeText(id)
            notification.success({ message: `${type} Id Copied` })

        } catch (error) {
            notification.error({ message: 'Something went wrong' })
        }
    }

    const downloadQRCode = async () => {
        const canvas = document.getElementById('myqrcode')?.querySelector('canvas');

        if (canvas) {
            // Wait for the QR code to render
            await new Promise(resolve => setTimeout(resolve, 500)); // Adjust the delay as needed

            const url = canvas.toDataURL();
            const a = document.createElement('a');
            a.download = 'QRCode.png';
            a.href = url;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    };



    return (
        <>

            <div>

                <Card className="my-5">
                    <Heading>Device List</Heading>
                    <Row>
                        <CRUDComponent

                            GET={{
                                API: CONSTANTS.API.Device.getAll,

                                DataModifier: (res, API, Setrefresh) => {
                                    // console.log(res, "GET ALL ABCD");
                                    return res?.map(data => {
                                        return {
                                            ...data,
                                            no: `D${data?.id.toString().padStart(7, "0")}`,
                                            view: {
                                                id: data?.id,
                                                onClick: (deviceId) => {
                                                    navigate(`/app/device/${deviceId}`)
                                                },
                                            },
                                            uniqueIdD: <div> {data?.uniqueId} <Tooltip title="Copy Unique Id"> <CopyOutlined onClick={() => {
                                                copyHandler(data?.uniqueId)
                                            }} /></Tooltip> </div> || '-',
                                            simId: data?.simId || '-',
                                            simStatus: data?.simStatus ? 'Yes' : 'No',
                                            deviceTypeId: DEVICE[data?.deviceTypeId],
                                            isActive: data?.isActive ? "Yes" : "No",
                                            DID_D: data?.DID ? <div> {data?.DID} <Tooltip title="Copy Device Id"> <CopyOutlined onClick={() => {
                                                copyHandler(data?.DID, 'Device')
                                            }} /></Tooltip> </div> : '-',
                                            qrcode: {
                                                id: data?.id,
                                                isDisable: !data?.DID,
                                                onClick: () => {
                                                    setQrData({
                                                        // uniqueId: data?.uniqueId,
                                                        // simId: data?.simId,
                                                        deviceDID: data?.DID,
                                                    })
                                                }
                                            },



                                        }
                                    })
                                },
                                column: role === 'Admin' ? CONSTANTS.TABLE.DEVICE_2 : CONSTANTS.TABLE.MANUFACTURER_DEVICE_2,
                                // column: deviceTypeId[1] === '1' ? CONSTANTS.TABLE.DEVICE_1 : CONSTANTS.TABLE.DEVICE_2,
                            }}
                            UPDATE={{
                                API: CONSTANTS.API.Device.update,
                                message: "Updated Device successfully",
                                modaltitle: "Update Device",
                                modalFields: CONSTANTS.FORM_FIELD.EDIT_DEVICES_MODAL,
                                // payloadModifier: (res) => {
                                //     return {
                                //         ...res,
                                //         animalType: 'D',
                                //     }
                                // },
                            }}
                            CREATE={{
                                API: CONSTANTS.API.Device.add,
                                message: "Created Device successfully",
                                modaltitle: "Add Device",
                                modalFields: CONSTANTS.FORM_FIELD.DEVICES_MODAL,
                                payloadModifier: (res) => {
                                    return {
                                        ...res,
                                        animalType: 'D',
                                    }
                                },
                            }}
                            DELETE={{
                                API: CONSTANTS.API.Device.delete,
                                message: "Deleted Device Successfully",
                            }}
                            isSearch={true}
                            QRdownload

                        />
                    </Row>
                </Card>
                <Modal
                    open={qrData !== null}
                    title={<p className="form-modal-head mb25">Generate QR Code</p>}
                    okText="Submit"
                    // width={1000}
                    centered
                    cancelButtonProps={{ style: { display: "none" } }}
                    okButtonProps={{ style: { display: "none" } }}
                    className="form-modal-title"
                    onCancel={() => setQrData(null)}
                    onOk={() => setQrData(null)}
                >
                    <div className='flex flex-col justify-center items-center ' >
                        <div id="myqrcode">
                            <QRCode

                                value={JSON.stringify(qrData)}
                                bgColor="#fff"
                                style={{
                                    marginBottom: 16,
                                }}
                            />
                        </div>
                        <Button type="primary" onClick={downloadQRCode}>
                            Download
                        </Button>

                    </div>
                </Modal>
            </div>

        </>
    )
}

export default Devices